import { Component, OnInit } from '@angular/core';
import {LoginService} from '../../login-service';
import { Route, Router, RouterModule } from '@angular/router';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent implements OnInit {
  IsSuperAdmin:boolean=false;
  showalert:boolean=true;
usersList:any=[];
emailID:any;
password:any;
userTypeSuperAdmin:string="SuperAdmin";
userTypeAdmin:string="Admin"
errorMessage:string;
errorMessage1:string;
  menuList: any;
  rolesList: any;
  usertype:string;
  constructor(private loginService:LoginService,private router:Router) {
    this.usertype='1';
   }

  ngOnInit(): void {
    this.GetUsers();
    this.GetRoles();
    this.GetAdminMenus(3);
    localStorage.removeItem('SIGNEDUPAS');
    // localStorage.setItem(PROCESS,'adminlogin')
  }
  GetAdminMenus(userTypeID){
    this.loginService.GetMenusByUserType("3").subscribe(data=>
      {
  
  data = JSON.parse(data['_body']);
  this.menuList=JSON.parse(JSON.stringify(data));
      });
  }
  GetUsers(){
    this.loginService.GetUsers(this.usertype).subscribe(data=>
      {
        data = JSON.parse(data['_body']);
        this.usersList = data;
      });
  }

  GetRoles(){
    this.loginService.GetRoles(this.usertype).subscribe(data=>
      {  
        data = JSON.parse(data['_body']);
              this.rolesList=JSON.parse(JSON.stringify(data));

  
  });
  }

  Login(){


    
    let validateUser=this.usersList.filter(x=>x.email.toLowerCase().toString()===this.emailID.toLowerCase().toString() && x.password.toLowerCase().toString()==this.password.toLowerCase().toString() && x.user_type.toLowerCase().toString()===this.userTypeSuperAdmin.toLowerCase().toString());
    if(validateUser.length>0)
    {
      this.IsSuperAdmin=true;
       if(validateUser[0].user_type==='SuperAdmin')
      {
        localStorage.setItem('userType',"SuperAdmin");
        localStorage.setItem("USERID",validateUser[0].id)
        localStorage.setItem("userID",validateUser[0].id);

        this.loginService.GetMenusByUserType("3").subscribe(data=>
          {
      
      data = JSON.parse(data['_body']);
      this.menuList=JSON.parse(JSON.stringify(data));
      let menuJson:any;
        let filterRole=this.rolesList.filter(x=>x.RoleID==validateUser[0].roleid);
        
      if(filterRole.length>0){
menuJson=JSON.parse(filterRole[0].MenuJson);
localStorage.setItem("MenuPermissions",menuJson);
      }
          
      localStorage.setItem("LOGGEDINAS","Admin");
    localStorage.setItem("roleID",validateUser[0].roleid);
    localStorage.setItem("menuData",this.menuList);
   
    localStorage.setItem("userType",validateUser[0].user_type_id);
    localStorage.setItem("userTypeid",validateUser[0].user_type_id);
    this.router.navigateByUrl('/admindashboard');
          });
        
        
      
      }
    }
    
    else 
      {
        this.IsSuperAdmin=false;
        if(this.emailID===''||this.emailID===undefined){
          this.errorMessage="Email ID is required";
        }
        else
        this.errorMessage=''
        if(this.password===''||this.password===undefined)
        {
          this.errorMessage+=  "   Password is required";
        }
        else
        this.errorMessage+='';
    
        if(this.emailID===''||this.emailID===undefined || this.password===''||this.password===undefined ){
          this.showalert=false;
        }
        else{
          let validateUser=this.usersList.filter(x=>x.email.toLowerCase().toString()===this.emailID.toLowerCase().toString() && x.password.toLowerCase().toString()==this.password.toLowerCase().toString() && x.user_type.toLowerCase().toString()===this.userTypeAdmin.toLowerCase().toString());
          if(validateUser.length>0)
          {
            this.IsSuperAdmin=true;
             if(validateUser[0].user_type==='Admin')
            {
                this.loginService.GetMenusByUserType("3").subscribe(data=>
                    {
                data = JSON.parse(data['_body']);
                this.menuList=JSON.parse(JSON.stringify(data));
                let menuJson:any;
                  let filterRole=this.rolesList.filter(x=>x.RoleID==validateUser[0].roleid);
                if(filterRole.length>0){
menuJson=JSON.parse(filterRole[0].MenuJson);
localStorage.setItem("MenuPermissions",menuJson);
                }
                    
              localStorage.setItem('userType',"Admin");
              localStorage.setItem("userID",validateUser[0].id);
              localStorage.setItem("USERID",validateUser[0].id);
              localStorage.setItem("roleID",validateUser[0].roleid);
              localStorage.setItem("menuData",this.menuList);
              localStorage.setItem("userType",validateUser[0].user_type_id);
              localStorage.setItem("userTypeid",validateUser[0].user_type_id);
              this.router.navigateByUrl('/admindashboard');
            });
          }
            
          }
        else{
          this.showalert=false;
          setTimeout(() => {
            this.errorMessage="User does not exist in cloud collabo."
            this.ClearFields();
            
          }, 1000);
         
        }
        }
       
      }
    

  }
  ClearFields(){
    this.emailID='';
    this.password='';
  }

}

